import React from "react";
import queryString from "query-string/index";
import LoadingSpinner from "../Utils/LoadingSpinner";
import Moment from 'react-moment/dist/index';
import {Link} from "react-router-dom";
import OrderStatus from "./OrderStatus";


class PaymentStatus extends React.Component {

    // State of this component
    state = {
        loading: true, // will be true when ajax request is running
        result: null,
        order_completed: false,
        timer: null,
    };

    componentDidMount() {
        this.updatePaymentStatus();
        let timer = setInterval(this.updatePaymentStatus, 10000);
        this.setState({
            timer: timer,
        });
    }

    componentWillUnmount() {
        if( this.clearInterval )  // Prevent crash on sign out
            this.clearInterval(this.state.timer);
    }

    componentDidUpdate(prevProps, prevState){
        console.log('State has changed');
        if(this.state.order_completed){
            console.log('No more need to update');
            clearInterval(this.state.timer);
        }
    }

    updatePaymentStatus = () => {
        let args = queryString.parse(this.props.location.search);

        this.props.simGps.getOrderStatus(args.order_id, args.client_secret, args.source, args.livemode,
            (success, result) => {
                if( success ){
                    const order_completed = (result.status === 'succeeded') ||
                        ((result.status === 'failed'));
                    this.setState({loading: false,
                        result: result,
                        order_completed: order_completed}
                    );
                }else{
                    const error = {
                        success: false,
                        message: JSON.stringify(result)
                    };
                    this.setState({loading: false, result: error});
                }
            });
    };

    render() {
        let orderStatus;

        if ( this.state.loading ){
            orderStatus =  (<LoadingSpinner text="Retrieving order status ..."/>);
        }else {
            if ( this.state.order_completed) {

                if (this.state.result.status === 'succeeded' ) {
                    orderStatus =  (
                     <div>
                         <h1>Your order was successfully completed.</h1>
                         <OrderStatus
                             {...this.state.result}
                         />
                    </div>
                    )
                }else {
                    orderStatus =  (<div>
                        Your order didn't go through <p><Link to="/orders">My Orders</Link></p>
                    </div>)
                }
            }else {
                orderStatus =  (
                    <div>
                        <h1>Your order is being processed.</h1>

                        You submitted the payment of {this.state.result.amount/100.}
                        &nbsp;{this.state.result.currency}&nbsp;
                        on&nbsp;<Moment unix>{this.state.result.modified_at}</Moment>

                         Please either wait on this page or
                        check your order status later at this link: <Link to="/orders">My Orders</Link>
                    </div>
                )
            }
        }
        return ( <div> {orderStatus} </div>)
    }
}

export default PaymentStatus;
